import { initComponent } from "../../../utilities/common";

export default class OfferSelector {
  constructor(element) {
    this.element = element;
    this.options = [...this.element.querySelectorAll(`[data-offer-info]`)];
    this.inputs = [...this.element.querySelectorAll(`input`)];
    this.form = this.element.closest("form");
    this.offerType = this.form.querySelector(`[name="offerType"]`);
    this.offerId = this.form.querySelector(`[name="oItemId"]`);
    this.sourceId = this.form.querySelector(`[name="sourceId"]`);
    this.offerTypeValue = "";
    this.offerIdValue = "";
    this.sourceIdValue = "";

    this.setupInputListeners();
    this.initializeDefaultValues();
  }

  addValues(input) {
    // Replace the current values with the selected input's data
    if (input.dataset.offerType) {
      this.offerTypeValue = input.dataset.offerType;
    }
    if (input.dataset.offerId) {
      this.offerIdValue = input.dataset.offerId;
    }
    if (input.dataset.sourceId) {
      this.sourceIdValue = input.dataset.sourceId;
    }
  }

  removeValues() {
    // Clear all values when unchecked
    this.offerTypeValue = "";
    this.offerIdValue = "";
    this.sourceIdValue = "";
  }

  updateFormFields() {
    this.offerType.value = this.offerTypeValue;
    this.offerId.value = this.offerIdValue;
    this.sourceId.value = this.sourceIdValue;
  }

  findDataElement(input) {
    return this.options.filter((o) => o.dataset.offerType === input.value)[0];
  }

  initializeDefaultValues() {
    // Find any pre-selected (checked) inputs and initialize the values
    this.inputs.forEach((i) => {
      if (i.checked) {
        const input = this.findDataElement(i);

        if (input) {
          this.addValues(input);
        }
      }
    });

    // Update the form fields with the initialized values
    this.updateFormFields();
  }

  setupInputListeners() {
    this.inputs.forEach((i) => {
      const input = this.findDataElement(i);

      i.addEventListener("change", () => {
        if (i.checked) {
          this.addValues(input);
        } else {
          this.removeValues();
        }
        this.updateFormFields();
      });
    });
  }
}

export const init = () => {
  initComponent("offer-selector", (element) => new OfferSelector(element));
};
init();
